import { useState, useEffect } from "react"
import { Row, Col, Segmented, Dropdown, Input } from 'antd'
import { useParams } from "react-router-dom";
import BackButton from '../../components/CustomButton/BackButton'
import { approveDeals, dealsUnderBusiness } from "../../redux/slices/dealsSlice";
import useSearchableTable from "../../hooks/useSearchableTable";
import { BTN_TXT } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux"
import PrimaryButton from "../../components/CustomButton/PrimaryButton"
import { ArrowDownOutlined } from "@ant-design/icons"
import Loader from "../../components/CustomLoader/Loader";
import ApproveDeal from "./Components/ApproveDeal"
import DealUnderBus from "./Components/DealUnderBus"
import { isSupplyChainCategory } from "../../helpers/dealCategoryProducts";

const dealSegments = [
    {
        label: "Approve Deal",
        value: 'approveDeal'
    },
    {
        label: "Deals under Business",
        value: 'dealUnderBus'
    },
];

const AssignDeal = () => {
    const dispatch = useDispatch();
    const dealId = useParams()?.dealId;
    const { approvedeal, loading, dealunderBus } = useSelector((state) => state?.deals);
    const [selectedTab, setSelectedTab] = useState('approveDeal');

    const isSupplyChain = isSupplyChainCategory(
        approvedeal?.dealDetails?.dealCategoryId || approvedeal?.dealDetails?.dealType
    );

    const { searchText, setSearchText, filteredData } =
        useSearchableTable(dealunderBus);

    useEffect(() => {
        dispatch(approveDeals(dealId));
    }, [dispatch, dealId])

    useEffect(() => {
        if (selectedTab === "dealUnderBus") {
            dispatch(dealsUnderBusiness(approvedeal?.dealDetails?.orgId));
        }
    }, [dispatch, approvedeal?.dealDetails?.orgId, selectedTab])

    const downloadInvoices = (fileUrl) => {
        if (!fileUrl) return;
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = "";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const menuItems = [
        {
            key: "1",
            label: (
                <span onClick={() => downloadInvoices(approvedeal?.dealDetails?.csvFileUrl)} style={{ margin: 10 }}>
                    {isSupplyChain ? (BTN_TXT.DWNLD_PO_CSV || "Download Purchase Order CSV") : BTN_TXT.DWNLD_INV_CSV}
                </span>
            ),
        },
        { type: "divider" },
        {
            key: "2",
            label: (
                <span onClick={() => downloadInvoices(approvedeal?.dealDetails?.invoiceFileUrl)} style={{ margin: 10 }}>
                    {isSupplyChain ? (BTN_TXT.DWNLD_PO_ZIP || "Download Purchase Order Zip") : BTN_TXT.DWNLD_INV_ZIP}
                </span>
            ),
        },
    ]

    return (
        <div className='assign-deal-container'>
            <BackButton />
            <Row gutter={[0, 16]} align="middle" justify="space-between" style={{ width: "100%" }}>
                <Col>
                    <div className="segmented-wrapper">
                        <Segmented
                            options={dealSegments}
                            value={selectedTab}
                            onChange={(value) => setSelectedTab(value)}
                            className="custom-segmented"
                        />
                    </div>
                </Col>
                <Col>
                    {selectedTab === "approveDeal" ? (
                        <Dropdown
                            menu={{ items: menuItems }}
                            trigger={["click"]}
                            overlayStyle={{
                                border: "1px solid #d9d9d9",
                                borderRadius: "8px",
                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <PrimaryButton
                                variant="solid"
                                color="primary"
                                icon={<ArrowDownOutlined />}
                                iconPosition="end"
                            >
                                {BTN_TXT.DOWNLOAD}
                            </PrimaryButton>
                        </Dropdown>
                    ) : (
                        <Input
                            placeholder="Search"
                            allowClear
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="search-input"
                        />
                    )}
                </Col>
            </Row>
            {loading ? <Loader /> : (
                <>
                    {selectedTab === "approveDeal" && (
                        <ApproveDeal deal={approvedeal} />
                    )}
                    {selectedTab === "dealUnderBus" && (
                        <DealUnderBus orgId={approvedeal?.dealDetails?.orgId} deal={filteredData} />
                    )}
                </>
            )}
        </div>
    )
}

export default AssignDeal